angular.module("imagenet")
    .factory('UserFactory', ['$http', 'TokenLibrary', '$q', 'API_URL', '$cookies', function ($http, TokenLibrary, $q, API_URL, $cookies) {
        'use strict';
        return {
            login: login,
            logout: logout,
            setpassword: setpassword,
            getUser: getUser,
            forgotPassword: forgotPassword,
        };

        var _user;

        function login(mail, password) {
            return $http.post(API_URL + '/api/auth/login', {
                mail: mail,
                password: password
            }).then(function success(response) {
                window.location = '/';
                return response;
            });
        }

        function setpassword(ver, pass){
            return $http.post(API_URL + '/api/auth/setpassword', {
                verification: ver,
                password: pass
            }).then(function success(response) {
                window.location = '/';
                return response;
            });
        }

        function forgotPassword(mail) {
            return $http.post(API_URL + '/api/auth/forgotpassword', {
                mail: mail
            });
        }

        function logout() {
            TokenLibrary.clear(); // tokeni null gönderince removeItem oluyo, siliyo
            $cookies.remove("loggedIn");
            window.location="/";
        }

        function getUser() {
            if (TokenLibrary.getRefreshToken()) {
                if (_user) return _user;
                _user = $http.get(API_URL + '/api/auth/');
                return _user;
            } else {
                return $q.reject({ data: 'client has no auth token' });
            }
        }
    }]);